/* 
  ========================================================================
  Ejemplo de GlobalPaginator:
  ========================================================================

  Dentro de un contenedor de tabla o lista:
      <GlobalPaginator
        totalItems={100} 
        itemsPerPage={10} 
        currentPage={currentPage} // Pagina actual en el estado local
        onPageChange={(page) => {
          // Lgica para actualizar la pagina actual y hacer un refetch de los datos
          setCurrentPage(page);
          // fetchRegistros({ page });
        }}
      />
*/
import React from 'react'
import Pagination from '@mui/material/Pagination'
import PaginationItem from '@mui/material/PaginationItem'

interface GlobalPaginatorProps {
  totalItems: number
  currentPage: number
  itemsPerPage: number
  from?: number
  to?: number
  onPageChange: (page: number) => void
}

export function GlobalPaginator({
  totalItems,
  itemsPerPage,
  currentPage,
  from,
  to,
  onPageChange,
}: GlobalPaginatorProps) {
  const totalPages = Math.ceil(totalItems / itemsPerPage)

  if (totalItems === 0) return null

  return (
    <div className="flex flex-col items-center justify-between gap-4 border-t border-border bg-table-bg text-table-foreground px-4 py-3 sm:flex-row sm:px-6 rounded-b-lg">
      <div className="flex items-center gap-4">
        <p className="text-sm text-table-foreground">
          Mostrando <span className="font-medium">{from ?? 0}</span> a{' '}
          <span className="font-medium">{to ?? 0}</span> de{' '}
          <span className="font-medium">{totalItems}</span> registros
        </p>
      </div>

      <div className="flex justify-center">
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(event, value) => onPageChange(value)}
          shape="circular"
          renderItem={(item) => (
            <PaginationItem
              {...item}
              style={
                item.selected
                  ? {
                      backgroundColor: 'var(--primary)',
                      color: '#ffffff',
                    }
                  : undefined
              }
            />
          )}
        />
      </div>
    </div>
  )
}
